import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ChatDisplay = _resolveComponent("ChatDisplay")!
  const _component_ChatInputText = _resolveComponent("ChatInputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header),
      _createVNode(_component_ChatDisplay),
      (_ctx.displayChat)
        ? (_openBlock(), _createBlock(_component_ChatInputText, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}